import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrderSearchConditionsResponse } from '~/types/delivery-agency.types';

const useGetOrdersSearchConditions = () => {
  const { runAsync } = useAsyncHandler();

  const getOrdersSearchConditions = useAPI<unknown, TypeGetOrderSearchConditionsResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_ORDERS_CODES,
    method: 'get',
  });

  const requestCodes = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: TypeGetOrderSearchConditionsResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  }) => {
    runAsync(() => getOrdersSearchConditions({}), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestCodes };
};

export default useGetOrdersSearchConditions;
